<template>
  <div class="content"/>
</template>

<script setup>
  import { defineOptions } from 'vue';

  defineOptions({
    name: 'Empty',
  });
</script>
